import { Loading } from '@/components/Loading'
import Step2Wrapper from '@/containers/steps/vehicle/Step2/Step2Wrapper'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import OffersAddonProvider from '@/context/OffersAddonProvider'
import { QuotesProvider } from '@/context/QuotesContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { WithAuth } from '@/hoc/WithAuth'
import { useInsurers } from '@/hooks'
import { useSaveBaseInsuranceParams } from '@/hooks/useWizardAddon'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { useEffect, useMemo } from 'react'

const Step2PageComponent = () => {
  const { insuranceParams, isLoadingData, refetchInsuranceParams } = useInsuranceParams()
  const ipDto = insuranceParams as InsuranceParamsDto
  const insurersLength = ipDto?.baseParams?.addonInsurers?.length ?? 0
  const { mutateAsync: saveBaseInsuranceParams, isPending: isLoadingSaveBaseParams } = useSaveBaseInsuranceParams()

  const existInsurers = useMemo(() => insurersLength > 0, [insurersLength])

  const { isLoading: isLoadingAddonInsurers, refetch, data: insurersData } = useInsurers(true, false, {
    enabled: false,
  })

  useEffect(() => {
    if (insurersData && ipDto && !isLoadingData && !isLoadingSaveBaseParams) {
      const data = insurersData.data
      if (!existInsurers && data.length >= 1) {
        const newAddonInsurers = data.map(x => x.id)

        saveBaseInsuranceParams({
          ...ipDto,
          baseParams: {
            ...ipDto.baseParams,
            addonInsurers: newAddonInsurers,
          }
        })
          .then(() => {
            refetchInsuranceParams()
          })
      }
    }
  }, [insurersData, existInsurers, ipDto, isLoadingData, isLoadingSaveBaseParams, saveBaseInsuranceParams, refetchInsuranceParams])

  useEffect(() => {
    if (insuranceParams)
      refetch()
  }, [insuranceParams])

  const isLoading = isLoadingData || isLoadingAddonInsurers || isLoadingSaveBaseParams || !existInsurers

  return (
    <StepsProvider currentStepId={2}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          <QuotesProvider>
            {isLoading && <Loading large={true} />}
            {!isLoading && ipDto &&
              <OffersAddonProvider>
                <Step2Wrapper />
              </OffersAddonProvider>
            }
          </QuotesProvider>
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const Step2Page = WithAuth(Step2PageComponent)